module.exports = __webpack_public_path__ + "img/25.b4d85c12.png";